import { getSignedParams, getPhpNow, getUUids, getUrlParams, getModel } from '@/utils';
import channelServer from './channelServer';
import store from '@/store';
import {
  mainTaskApi,
  nirvanaApi,
  roleReportApi,
  clientEventApi,
  onlineApi,
  lnsdkLoginApi,
  fushionLoginApi,
  createPageApi,
  initializeApi,
  selectServerApi,
  finishServerApi,
  certApi,
  enterGameApi,
  clearCacheApi,
  activateApi,
  gameLoadApi
} from '@/api/statis';

// 统计sdk
const statisServer = {
  reNum: 0, // 重试次数融合登录
  reNumLoginLn: 0, // 重试次数乐牛登录
  reNumRole: 0, // 重试次数角色上报
  timerLogin: null,
  isLnLogin: true,
  isFuLogin: true,
  getCommonParams() {
    this.commonParams = {
      series_id: store.state.series_id,
      package_version: parseInt(getUrlParams('ver') || 0),
      campaign: getUrlParams('campaign_id') || '',
      event: '',
      game_id: parseInt(getUrlParams('game_id') || 0),
      fu_appid: Number(getUrlParams('appid') || 0),
      package_name: getUrlParams('package_name') || 'h5',
      sdk_channel: getUrlParams('sdk_channel') || 'leniu',
      game_zone_id: store.state.zoneId || '',
      is_charge: getUrlParams('is_charge') || 0,
      network: getUrlParams('is_charge') || 0,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      properties: [],
      device: {
        type: getUrlParams('uuid') ? 2 : 7,
        uuid: getUUids() || '',
        idfa: getUrlParams('idfa') || '',
        idfv: getUrlParams('idfv') || '',
        caid: getUrlParams('caid') || '',
        imei: getUrlParams('imei') || '',
        oaid: getUrlParams('oaid') || '',
        android_id: getUrlParams('android_id') || '',
        model: getUrlParams('model') || getModel(),
        os_version: getUrlParams('os_version') || '',
        is_root: getUrlParams('is_root') || 0,
        is_emulator: getUrlParams('is_emulator') || 0
      }
    };
  },
  // 主线任务
  mainTask(params) {
    try {
      this.getCommonParams();
      this.commonParams.properties = params;
      mainTaskApi(this.commonParams, 'main_task').then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 转生信息上报
  nirvana(params) {
    try {
      this.getCommonParams();
      this.commonParams.properties = params;
      nirvanaApi(this.commonParams, 'nirvana').then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 创角页上报
  createPage(params) {
    try {
      this.getCommonParams();
      this.commonParams.properties = params;
      createPageApi(this.commonParams, 'role_create_page').then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 初始化及加载资源上报
  initialize(params) {
    try {
      this.getCommonParams();
      this.commonParams.properties = params;
      initializeApi(this.commonParams, 'initialize').then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 选服页上报
  selectServer(params) {
    try {
      this.getCommonParams();
      this.commonParams.properties = params;
      console.log(store.state.zoneId);
      selectServerApi(this.commonParams, 'select_server').then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 完成选服上报
  finishServer(params) {
    try {
      this.getCommonParams();
      this.commonParams.properties = params;
      finishServerApi(this.commonParams, 'finish_server').then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 实名认证上报
  cert(params) {
    try {
      this.getCommonParams();
      this.commonParams.properties = params;
      certApi(this.commonParams, 'cert').then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 进入游戏主界面上报
  enterGame(params) {
    try {
      this.getCommonParams();
      this.commonParams.properties = params;
      enterGameApi(this.commonParams, 'enter_to_game').then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 激活上报
  activate(params) {
    try {
      this.getCommonParams();
      this.commonParams.properties = params;
      activateApi(this.commonParams, 'activate').then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 游戏初始化自定义事件上报
  clientEvent(params) {
    try {
      this.getCommonParams();
      this.commonParams.properties = [params.data];
      clientEventApi(this.commonParams, params.event).then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 融合登录上报
  fusion_login(params) {
    try {
      if (!this.isFuLogin && !store.state.isClickChangeAcc) return;
      this.getCommonParams();
      this.commonParams.properties = params;
      fushionLoginApi(this.commonParams, 'fusion_login').then(data => {
        this.reNum++;
        // 网络问题重试机制，分5次时间间隔分别为0s、1s、3s、5s、7s，重试失败后存本地，重新打开APP后继续重试，直至接口返回上报成功
        if (data.status != 200 || data.data.ret != 0) {
          if (this.reNum > 5) return;
          switch (this.reNum) {
            case 1:
              setTimeout(() => {
                this.fusion_login(params);
              }, 1000);
              break;
            case 2:
              setTimeout(() => {
                this.fusion_login(params);
              }, 3000);
              break;
            case 3:
              setTimeout(() => {
                this.fusion_login(params);
              }, 5000);
              break;
            case 4:
              setTimeout(() => {
                this.fusion_login(params);
              }, 7000);
              break;
            case 5:
              localStorage.setItem('statis_ln_fulogin', JSON.stringify(this.commonParams));
              break;
            default:
              break;
          }
        } else {
          if (!store.state.isClickChangeAcc) {
            this.isFuLogin = false;
          }
        }
        // console.log(data)
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 角色上报
  roleReport(params, type) {
    try {
      const limitAppId = ['70652', '70660'];
      if (limitAppId.includes(String(getUrlParams('appid'))) && type == 2) {
        return;
      }
      let event = type == 1 ? 'create_role' : type == 2 ? 'level_up' : 'enter_game';
      this.commonParams.properties = params;
      roleReportApi(this.commonParams, event).then(data => {
        // 网络问题重试机制，分5次时间间隔分别为0s、1s、3s、5s、7s，重试失败后存本地，重新打开APP后继续重试，直至接口返回上报成功
        if (data.status != 200 || data.data.ret != 0) {
          if (this.reNumRole > 5) return;
          switch (this.reNumRole) {
            case 1:
              setTimeout(() => {
                this.roleReport(params, type);
              }, 1000);
              break;
            case 2:
              setTimeout(() => {
                this.roleReport(params, type);
              }, 3000);
              break;
            case 3:
              setTimeout(() => {
                this.roleReport(params, type);
              }, 5000);
              break;
            case 4:
              setTimeout(() => {
                this.roleReport(params, type);
              }, 7000);
              break;
            case 5:
              localStorage.setItem('statis_ln_role', JSON.stringify(this.commonParams));
              localStorage.setItem('statis_ln_role_ev', event);
              break;
            default:
              break;
          }
        }
        // console.log(data)
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 在线时长上报
  onlineReport(params) {
    try {
      const limitAppId = ['70652', '70660'];
      if (limitAppId.includes(String(getUrlParams('appid')))) return;
      this.getCommonParams();
      this.commonParams.properties = params;
      onlineApi(this.commonParams, 'online').then(data => {
        // console.log(data)
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 乐牛sdk完成登录上报
  lnsdkLogin(params) {
    try {
      if (!this.isLnLogin && !store.state.isClickChangeAcc) return;
      this.getCommonParams();
      this.commonParams.properties = params;
      lnsdkLoginApi(this.commonParams, 'lnsdk_login').then(data => {
        // 网络问题重试机制，分5次时间间隔分别为0s、1s、3s、5s、7s，重试失败后存本地，重新打开APP后继续重试，直至接口返回上报成功
        if (data.status != 200 || data.data.ret != 0) {
          if (this.reNumLoginLn > 5) return;
          switch (this.reNumLoginLn) {
            case 1:
              setTimeout(() => {
                this.lnsdkLogin(params);
              }, 1000);
              break;
            case 2:
              setTimeout(() => {
                this.lnsdkLogin(params);
              }, 3000);
              break;
            case 3:
              setTimeout(() => {
                this.lnsdkLogin(params);
              }, 5000);
              break;
            case 4:
              setTimeout(() => {
                this.lnsdkLogin(params);
              }, 7000);
              break;
            case 5:
              localStorage.setItem('statis_ln_login', JSON.stringify(this.commonParams));
              break;
            default:
              break;
          }
        } else {
          if (!store.state.isClickChangeAcc) {
            // console.log(store.state.isClickChangeAc)
            this.isLnLogin = false;
          }
        }
        // console.log(data, params)
      });
    } catch (error) {
      console.log(error);
    }
  },
  // 获取cp传的ZoneId
  getZoneId(zoneId) {
    store.commit('SET_ZONEID', zoneId);
    // 统计sdk首次打开调用激活上报
    this.activate([]);
  },
  // 清除缓存上报
  clearCacheApi(params) {
    try {
      this.getCommonParams();
      this.commonParams.properties = params;
      clearCacheApi(this.commonParams, 'user_clean_cache').then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  },
  gameLoad(event) {
    try {
      this.getCommonParams();
      this.commonParams.properties = [];
      gameLoadApi(this.commonParams, event).then(data => {
        console.log(data);
      });
    } catch (error) {
      console.log(error);
    }
  }
};

export default statisServer;
